<template>
  <v-app>
    <router-view />
    <GlobalSnackbar />
  </v-app>
</template>

<script>
export default {
  name: 'LayoutEmpty'
}
</script>
